import { Component, Input, Output, EventEmitter, HostListener, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'bb-modal',
	templateUrl: './bb-modal.component.html',
	styleUrls: ['./bb-modal.component.scss']
})

export class BbModalComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() icon: string;
	@Input() showCloseButton: boolean;
	@Input() class: 'media-selector';

	@Output() onClose = new EventEmitter();

	constructor(private el: ElementRef, private renderer: Renderer2) {
		this.showCloseButton = true;
	}

	@HostListener('document:keyup', ['$event'])
	onKeyUp(ev: KeyboardEvent) {
		if (ev.key === 'Escape') {
			this.close();
		}
	}

	ngOnInit() {
		if (this.class) {
			this.renderer.addClass(this.el.nativeElement, this.class);
		}
	}

	ngOnDestroy() { }

	close() {
		this.onClose.emit();
	}
}
